<template>
  <div>
    <cReviewHotel
      :hotelObj="sHotelObj"
      :isToggleOption="true"
      :isEditOption="true"
      :isShowLeftPart="true"
      :isHideDetails="true"
    />
    <CCardHeader class="grey-header">
      <CRow class="flex-flow-column">
        <CCol>
          <strong>{{ $t("tariffSetup.title") }}</strong>
        </CCol>

        <p class="desc">{{ $t("tariffSetup.desc") }}</p>
      </CRow>
    </CCardHeader>
    
    <ValidationObserver v-slot="{ handleSubmit }">
      <CForm  >
        <div v-if="hotelTariffObj && sHotelObj && sRoomObj " class="w-100 max-w-1100 m-auto">
          <cRoomInfoBox v-if="GET_RATE_PLAN && GET_RATE_PLAN.length"
            :hotelObj="sHotelObj"
            :roomObj="sRoomObj"
            :selValue.sync="hotelTariffObj.ratePlan"
            @getSelRatePlan="getSelectedRatePlan"
          />
        </div>

        <div class="card assign pricing-card">
          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.stayDate')}}</label>
                </p>
              </CCol>
              <div class="col">
                <ValidationProvider :rules="'required'" v-slot="{ errors }">
                  <CCol class="ext-date-wrapper w-100" v-model="hotelTariffObj.toDate">
                     <v-md-date-range-picker
                     v-if="showTicketDate"
                              :autoApply="true"
                              :showYearSelect="true"
                              @change="onChangeTravelDate"
                              :allowPastPresets="false"
                                :disableBefore='new Date().toString()'
                            >
                              <template slot="input">
                                <datePickerInput
                                  :fromDate="hotelTariffObj.fromDate?hotelTariffObj.fromDate:null"
                                  :toDate="hotelTariffObj.toDate?hotelTariffObj.toDate:null"
                                  :fromLabel="$t('addContract.fromLabel')"
                                  :toLabel="$t('addContract.toLabel')"
                                />
                              </template>
                    </v-md-date-range-picker>
                       <span class="input-group-btn tooltipIconAlign d-flex ai-center right-pa-icon" >  
                <img src="@imgPath/img/svg/icons/help.svg" alt=""  width="15px"  v-c-tooltip.hover="{
                              content: $t('hotelInfo.datePickerToolTip'),
                            }" >                  

              </span>
                    <!-- <HotelDatePicker
                      :showYear="true"
                      :startingDateValue="hotelTariffObj.fromDate?new Date(hotelTariffObj.fromDate):null"
                      :endingDateValue="hotelTariffObj.toDate?new Date(hotelTariffObj.toDate):null"
                      :hoveringTooltip="false"
                      :displayClearButton="false"
                      format="dddd, MMM DD"
                      @check-in-changed="onChangeStayFromDate"
                      @check-out-changed="onChangeStayToDate"
                      :i18n="assigni18nObjByLang(hotelTariffObj.fromDate,hotelTariffObj.toDate)"
                      ref="hotelDatePicker"
                      :minNights="0"
                    /> -->
                  </CCol>
                  <div v-if="errors && errors[0]" class="invalid-feedback icon">
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
        <div class="card assign pricing-card">
          <div>
            <h3>{{$t('tariffSetup.fares')}}</h3>
            <br />
          </div>

          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.singleOccupancyFare')}}</label>
                </p>
              </CCol>

              <div class="col-6">
                <cTextInputComponent
                  v-model="hotelTariffObj.singleFare"
                  :placeholder="$t('tariffSetup.amountPl')"
                  class="w-100"
                  :rules="'required|onlynumber'"
                  :isAmountField="true"
                  :maxLength="15"
                ></cTextInputComponent>
              </div>
            </div>
          </div>
          <br />
          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.doubleOccupancyFare')}}</label>
                </p>
              </CCol>

              <div class="col-6">
                <cTextInputComponent
                  v-model="hotelTariffObj.doubleFare"
                  :placeholder="$t('tariffSetup.amountPl')"
                  class="w-100"
                  :rules="'required|onlynumber'"
                  :isAmountField="true"
                ></cTextInputComponent>
              </div>
            </div>
          </div>
          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.fullOccupancyFare')}}</label>
                </p>
              </CCol>

              <div class="col-6">
                <cTextInputComponent
                  v-model="hotelTariffObj.fullOccupancyFare"
                  :placeholder="$t('tariffSetup.fullOccupancyFare')"
                  class="w-100"
                  :rules="'required|onlynumber'"
                  :isAmountField="true"
                ></cTextInputComponent>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div class="card assign pricing-card">
          <div>
            <h3>{{$t('tariffSetup.applicableDays')}}</h3>
            <br />
          </div>
          <!-- <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center">
                  <label>{{ $t('tariffSetup.numberOfDaysToStay')}}</label>
                </p>
              </CCol>

              <div class="col-3">
                <cTextInputComponent
                  v-model="hotelTariffObj.minStay"
                  :placeholder="$t('tariffSetup.minStayPl')"
                  class="w-100"
                  :rules="'onlyNumber'"
                  :maxLength="3"
                ></cTextInputComponent>
              </div>
              <div class="col-3">
                <cTextInputComponent
                  v-model="hotelTariffObj.maxStay"
                  :placeholder="$t('tariffSetup.maxStayPl')"
                  class="w-100"
                  :rules="'onlyNumber'"
                  :maxLength="3"
                ></cTextInputComponent>
              </div>
            </div>
          </div> -->
          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.cutOffDays')}}</label>
                </p>
              </CCol>

              <div class="col-3">
                <cTextInputComponent
                  v-model="hotelTariffObj.cutOfDate"
                  :placeholder="$t('tariffSetup.cutOffDatePl')"
                  class="w-100"
                  :rules="'required|onlynumber'"
                  :maxLength="3"
                ></cTextInputComponent>
              </div>
              <span class="d-flex">
                <!-- class="d-flex" -->
                <cHelpTip
                  :content="$t('tariffSetup.cutOffTooltip')"
                ></cHelpTip>
              </span>
            </div>
          </div>
          <br />

          <div class="w-100 max-w-800 m-auto">
            <div class="subtitile-details">
              <CCol class="col-3 d-flex">
                <p class="v-center field-wrapper required-field">
                  <label>{{ $t('tariffSetup.applicableDaysOfWork')}}</label>
                </p>
              </CCol>

              <div class="col">

                <cWeekDays @onDaysSelection='updateApplicableDays' :selDays='selApplicableDays' >
                  
                </cWeekDays>
                <!-- <div class="d-flex">








                  
                  <div
                    class="checkbox d-flex align-item-center mr-15px"
                    v-for="(day, index) in lsApplicableDays"
                    :key="index"
                  >
                    <input
                      type="checkbox"
                      class="m-auto mr-10px ml-0px c-pointer"
                      :id="day.name"
                      v-on:input="updateApplicableDays(day)"
                      :checked="
                    selApplicableDays.some(
                      (val) => val.code == day.code
                    )
                  "
                    />

                    <label :for="day.name" :class="'mb-0 c-pointer'">{{day.name}}</label>
                  </div>
                </div>
                 <ValidationProvider :rules="'required'" v-slot="{ errors }">
                            <CRow v-model="selApplicableDays"></CRow>
                            <div v-if="errors && errors[0]" class="invalid-feedback icon">
                                <span>{{ errors[0] }}</span>
                            </div>
                        </ValidationProvider> -->
                
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-between">
          <div class="d-flex justify-content-end">
            <CCol class="pl-0px">
              <CButton
                color="danger"
                @click="goBackToHotelInfo"
                class="action-c-btn"
              >{{ $t('tariffSetup.cancel')}}</CButton>
            </CCol>
            <CCol class="pr-0px">
              <CButton
                color="success"
                @click.prevent="handleSubmit(onConfirmCreateHotelTariff)"
                class="action-c-btn white-space-pre"
              >{{ GET_SEL_TARIFF?$t('tariffSetup.update'):$t('tariffSetup.create')}}</CButton>
            </CCol>
          </div>
        </div>
      </CForm>
    </ValidationObserver>
    <cAlertModal
      v-if="isShowAlertModal"
      :key="'tariff'+alertCount"
      :buttonList="modalButton"
      :status="modalStatus"
      :isShowIcon="true"
      :show="isShowAlertModal"
      :desc="confirmTxt"
    ></cAlertModal>
  </div>
</template>
<script>
import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import BaseConfiguration from "../../../../../config/base.js";
import {
  COMPONENT_NAME,
  PATHNAME,
  ALERT_MODAL_STATUS,
  DATE_TIME_FORMAT,
} from "../../../../../util/constants";
import Logger from "../../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES
} from "../../../../../config/API_DATA";
import { mapGetters ,mapActions} from "vuex";
import cTextInputComponent from "../../../../../components/form/cTextInputComponent";
import { VMdDateRangePicker } from "material-vue-date-picker";
import cRoomInfoBox from "../../../../../components/hms/manage/hotelInfo/cRoomInfoBox";
import HotelDatePicker from "vue-range-datechooser";
import { formatDate, addDays,isPastDate } from "../../../../../util/date/dateFunctions";
import cHelpTip from "../../../../../components/cHelpTip";
import Router, { goBack, updateDataEdited } from "../../../../../router";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import datePickerInput from "../../../../../components/datePicker/datePickerInput";
import {
  cloneData,
  getErrorAlertValue,
  handleJWT,
  addClassToBody,
  removeClassBody, cloneDeep
} from "../../../../../util/util";
import apiCreateHotelTariff from "../../../../../services/apiCreateHotelTariff.js";
import apiUpdateHotelTariff from "../../../../../services/apiUpdateHotelTariff.js";
import apiGetRatePlan from '../../../../../services/apiGetRatePlan'
import cAlertModal from "../../../../../components/form/cAlertModal";
import cWeekDays from "../../../../../components/form/cWeekDays"
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage
} from "../../../../../util/apiValidate";
import Vue from "vue";

export default {
  name: COMPONENT_NAME.TARIFF_NEW,

  components: {
    cReviewHotel,
    cRoomInfoBox,
    cTextInputComponent,
     datePickerInput,
    VMdDateRangePicker,
    HotelDatePicker,
    cHelpTip,
    ValidationObserver,
    cAlertModal,
    cWeekDays,
    ValidationProvider
  },
  data: () => {
    return {
      showTicketDate: true,
      hotelTariffObj: {
        ratePlan: null,
        fromDate: null,
        toDate: null,
        singleFare: null,
        doubleFare: null,
        fullOccupancyFare: null,
        minStay: null,
        maxStay: null,
        cutOfDate: null
      },
      lsApplicableDays: [],
      selApplicableDays: [],
      alertValue: null,
      alertCount: 0,
      isShowAlertModal: false,
      modalStatus: ALERT_MODAL_STATUS.INFO,
      modalButton: null,
      confirmTxt: null
    };
  },
  computed: {
    ...mapGetters("shmsManage", {
      sHotelObj: "GET_SEL_HOTEL",
      GET_ALL_ENUMS: "GET_ALL_ENUMS"
    }),
    ...mapGetters("sHotelInfo", {
      sRoomObj: "GET_HOTEL_ROOM_OBJ",
      GET_RATE_PLAN: "GET_RATE_PLAN"
    }),
    ...mapGetters("sTariff", {
      GET_SEL_TARIFF: "GET_SEL_TARIFF",
      GET_TARIFF_REQ:"GET_TARIFF_REQ"
    })
  },
 async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");
      this.getLsApplicableDays();
      if (this.GET_SEL_TARIFF) {
        ///for update tariff
        this.assignHotelTariffValues(this.GET_SEL_TARIFF);
      }

      else
      {
              this.selApplicableDays= ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"]

              if(Router && Router.currentRoute && Router.currentRoute.query && Router.currentRoute.query.roomId )

                  await this.handleQuery(Router.currentRoute.query)
      }
     
    } catch (err) {
      let body = Logger.buildRequest(
        COMPONENT_NAME.TARIFF_NEW,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  methods: {

    ...mapActions('sHotelInfo',{SET_RATE_PLAN:'SET_RATE_PLAN'}),


   async handleQuery(pTariff) {
    
        try {
          if(BaseConfiguration.isDebug) console.log("handleQuery");
          if(pTariff.roomId)
      {
        await this.setRatePlan(pTariff.roomId)
        this.hotelTariffObj.ratePlan= this.GET_RATE_PLAN.find(ratePlan=> ratePlan.id==pTariff.rpId)
        this.hotelTariffObj =cloneDeep(this.hotelTariffObj)
      }
     
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.TARIFF_NEW,
                  "error in handleQuery",
                  err.toString(),
                  "handleQuery",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 
     async setRatePlan(pHotelRoomId) {
   
      try {
        if (BaseConfiguration.isDebug) console.log("setRatePlan");

        if (this.sHotelObj) {
          let ratePlanReq = apiGetRatePlan.buildRequest(
            this.sHotelObj.hotelid,
            pHotelRoomId
          );

          if (ratePlanReq) {
            // this.SET_AGENCY_REQ(getRoutesRequest); //save req in store
            let ratePlanRes = await apiGetRatePlan.getResponse(ratePlanReq);

            if (VALIDATE_SUCCESS_RES(ratePlanRes)) {
                  let lsRatePlans = ratePlanRes.data.data.list;
                this.SET_RATE_PLAN(cloneDeep( lsRatePlans));
            } else {
              let error = getErrorMessage(ratePlanRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                   getErrorAlertValue(error)
              }
            }
          }
        } else {
          throw "invalid hotel  obj";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CANCELLATION_NEW,
          "error in setRatePlan",
          err.toString(),
          "setRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    
    },

    onChangeTravelDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");
        //  console.error(pDateList)
        this.showTicketDate = false;
        this.hotelTariffObj.fromDate = !isPastDate(pDateList[0]._d)
          ? pDateList[0]._d
          : new Date();
        this.hotelTariffObj.toDate = !isPastDate(pDateList[1]._d)
          ? pDateList[1]._d
          : new Date();
        this.showTicketDate = true;
        let that = this;
        setTimeout(function () {
          that.showTicketDate = true;
        });
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.CONTRACT_NEW,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignHotelTariffValues(pTariffObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignHotelTariffValues");

        this.hotelTariffObj.ratePlan = this.getRatePlanObj(this.GET_TARIFF_REQ);
        this.hotelTariffObj.fromDate = pTariffObj.stayfrom;
        this.hotelTariffObj.toDate = pTariffObj.stayto;
        this.hotelTariffObj.singleFare = pTariffObj.singleOccupancyFare?pTariffObj.singleOccupancyFare:pTariffObj.singleOccupancyFare==0?'0':null;
        this.hotelTariffObj.doubleFare = pTariffObj.doubleOccupancyFare?pTariffObj.doubleOccupancyFare:pTariffObj.doubleOccupancyFare==0?'0':null;
        this.hotelTariffObj.fullOccupancyFare = pTariffObj.fullOccupancyFare?pTariffObj.fullOccupancyFare:pTariffObj.fullOccupancyFare==0?'0':null;
        this.hotelTariffObj.minStay = pTariffObj.minStay?pTariffObj.minStay:pTariffObj.minStay==0?'0':null;
        this.hotelTariffObj.minStay = pTariffObj.minStay?pTariffObj.minStay:pTariffObj.minStay==0?'0':null;
        this.hotelTariffObj.cutOfDate = pTariffObj.cutoffdays? pTariffObj.cutoffdays: pTariffObj.cutoffdays==0?'0':null;
       
     this.selApplicableDays=pTariffObj.applicableDays
      //  this.assignSelApplicableDays(pTariffObj);
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in assignHotelTariffValues",
          err.toString(),
          "assignHotelTariffValues",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getRatePlanObj(pTariffReq) {
      let retValue = null;
      try {
        if (BaseConfiguration.isDebug) console.log("getRatePlanObj");
        if (this.GET_RATE_PLAN && pTariffReq&&pTariffReq.ratePlan) {
          for (let i = 0; i < this.GET_RATE_PLAN.length; i++) {
            if (this.GET_RATE_PLAN[i].id == pTariffReq.ratePlan) {
              retValue = this.GET_RATE_PLAN[i];
              break;
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getRatePlanObj",
          err.toString(),
          "getRatePlanObj",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    onConfirmCreateHotelTariff() {
      try {
        if (BaseConfiguration.isDebug)
          console.log("onConfirmCreateHotelTariff");
        if (this.GET_SEL_TARIFF) {
          this.showAlertModal(
            ALERT_MODAL_STATUS.INFO,
            this.$t("tariffSetup.updateTariffConfirmation")
          );
        } else {
          this.showAlertModal(
            ALERT_MODAL_STATUS.INFO,
            this.$t("tariffSetup.createTariffConfirmation")
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in onConfirmCreateHotelTariff",
          err.toString(),
          "onConfirmCreateHotelTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getSelectedRatePlan(pRatePlan) {
      try {
        if (BaseConfiguration.isDebug) console.log("getSelectedRatePlan");
        this.hotelTariffObj.ratePlan = pRatePlan;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getSelectedRatePlan",
          err.toString(),
          "getSelectedRatePlan",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assignSelApplicableDays(pTariffObj) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignSelApplicableDays");
        if (pTariffObj) {
          for (let i = 0; i < pTariffObj.applicableDays.length; i++) {
            if (this.GET_ALL_ENUMS.weekDays[pTariffObj.applicableDays[i]]) {
              let dayObj = {
                name: this.GET_ALL_ENUMS.weekDays[pTariffObj.applicableDays[i]],
                code: pTariffObj.applicableDays[i]
              };
              this.selApplicableDays.push(dayObj);
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in assignSelApplicableDays",
          err.toString(),
          "assignSelApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getAppliDaysForReq(pSelAppliDays) {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getAppliDaysForReq");
        for (let i = 0; i < pSelAppliDays.length; i++) {
          retValue.push(pSelAppliDays[i].code);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getAppliDaysForReq",
          err.toString(),
          "getAppliDaysForReq",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getCreateTariffRequest(pHotelTariffObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getCreateTariffRequest");

        retValue = {
          hotelId: this.sHotelObj.hotelid,
          roomId: this.sRoomObj.roomid,
          ratePlan: pHotelTariffObj.ratePlan
            ? pHotelTariffObj.ratePlan.id
            : null,
          fromDate: formatDate(pHotelTariffObj.fromDate, "YYYY-MM-DD"),
          toDate: formatDate(pHotelTariffObj.toDate, "YYYY-MM-DD"),
          singleFare: Number(pHotelTariffObj.singleFare),
          doubleFare: Number(pHotelTariffObj.doubleFare),
          fullOccupancyFare: Number(pHotelTariffObj.fullOccupancyFare),
          minStay: Number(pHotelTariffObj.minStay),
          maxStay: Number(pHotelTariffObj.maxStay),
          cutOfDate: Number(pHotelTariffObj.cutOfDate),
          applicableDays: this.selApplicableDays
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getCreateTariffRequest",
          err.toString(),
          "getCreateTariffRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    getUpdateTariffRequest(pHotelTariffObj) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getUpdateTariffRequest");

        retValue = {
          hotelId: this.sHotelObj.hotelid,
          roomId: this.sRoomObj.roomid,
          tariffId: this.GET_SEL_TARIFF.tariffid,
          ratePlan: pHotelTariffObj.ratePlan
            ? pHotelTariffObj.ratePlan.id
            : null,
          fromDate: formatDate(pHotelTariffObj.fromDate, "YYYY-MM-DD"),
          toDate: formatDate(pHotelTariffObj.toDate, "YYYY-MM-DD"),
          singleFare: Number(pHotelTariffObj.singleFare),
          doubleFare: Number(pHotelTariffObj.doubleFare),
          fullOccupancyFare: Number(pHotelTariffObj.fullOccupancyFare),
          minStay: Number(pHotelTariffObj.minStay),
          maxStay: Number(pHotelTariffObj.maxStay),
          cutOfDate: Number(pHotelTariffObj.cutOfDate),
          applicableDays: this.selApplicableDays
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getUpdateTariffRequest",
          err.toString(),
          "getUpdateTariffRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async updateHotelTariff(pHotelReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelTariff");
        let hotelReq = apiUpdateHotelTariff.buildRequest(pHotelReq);

        if (hotelReq) {
          let hotelRes = await apiUpdateHotelTariff.getResponse(hotelReq);

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in updateHotelTariff",
          err.toString(),
          "updateHotelTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async createHotelTariff(pHotelReq) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("createHotelTariff");
        let hotelReq = apiCreateHotelTariff.buildRequest(pHotelReq);

        if (hotelReq) {
          let hotelRes = await apiCreateHotelTariff.getResponse(hotelReq);

          if (VALIDATE_SUCCESS_RES(hotelRes)) {
            this.alertValue = null;
            retValue = hotelRes.data.data;
          } else {
            let error = getErrorMessage(hotelRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              this.alertValue = getErrorAlertValue(error, true, true);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in createHotelTariff",
          err.toString(),
          "createHotelTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    toggleShowAlertModal() {
      this.isShowAlertModal = !this.isShowAlertModal;
    },
    showAlertModal(status, val) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;
      this.confirmTxt = val;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("tariffSetup.noBtn"),
            func: this.toggleShowAlertModal
          },
          {
            name: this.$t("tariffSetup.yesBtn"),
            func: this.onCreateHotelTariff
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.SUCCESS) {
        this.modalButton = [
          {
            name: this.$t("tariffSetup.okBtn"),
            func: this.goBackToHotelInfo
          }
        ];
      } else if (status == ALERT_MODAL_STATUS.FAIL) {
        this.modalButton = [
          {
            name: this.$t("tariffSetup.okBtn"),
            func: this.toggleShowAlertModal
          }
        ];
      }
    },
    async onCreateHotelTariff() {
      try {
        if (BaseConfiguration.isDebug) console.log("onCreateHotelTariff");
        updateDataEdited(false);

        // if (getAllAirlineReq) {
        if (this.GET_SEL_TARIFF) {
          let tariffRequest = this.getUpdateTariffRequest(this.hotelTariffObj);
          if (tariffRequest) {
            let retHotelRes = await this.updateHotelTariff(tariffRequest);

            if (retHotelRes) {
              this.showAlertModal(
                ALERT_MODAL_STATUS.SUCCESS,
                this.$t("tariffSetup.tariffUpdatedSuccDesc")
              );
            } else {
              this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
            }
          } else {
            throw "invalid request";
          }
        } else {
          let tariffRequest = this.getCreateTariffRequest(this.hotelTariffObj);
          if (tariffRequest) {
            let retHotelRes = await this.createHotelTariff(tariffRequest);
            if (retHotelRes) {
              this.showAlertModal(
                ALERT_MODAL_STATUS.SUCCESS,
                this.$t("tariffSetup.tariffCreatedSuccDesc")
              );
            } else {
              this.showAlertModal(ALERT_MODAL_STATUS.FAIL, this.alertValue);
            }
          } else {
            throw "invalid request";
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in onCreateHotelTariff",
          err.toString(),
          "onCreateHotelTariff",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    updateApplicableDays(pWeekDays) {
      try {
        if (BaseConfiguration.isDebug) console.log("updateApplicableDays");

        if (pWeekDays && pWeekDays.length) {


          this.selApplicableDays = cloneDeep(pWeekDays) 
  
        } else {
           this.selApplicableDays=[];
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in updateApplicableDays",
          err.toString(),
          "updateApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    getLsApplicableDays() {
      try {
        if (BaseConfiguration.isDebug) console.log("getLsApplicableDays");

        for (
          let i = 0;
          i < Object.keys(this.GET_ALL_ENUMS.weekDays).length;
          i++
        ) {
          let dayObj = {
            code: Object.keys(this.GET_ALL_ENUMS.weekDays)[i],
            name: Object.values(this.GET_ALL_ENUMS.weekDays)[i]
          };
          this.lsApplicableDays.push(dayObj);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in getLsApplicableDays",
          err.toString(),
          "getLsApplicableDays",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    goBackToHotelInfo() {
      try {
        if (BaseConfiguration.isDebug) console.log("goBackToHotelInfo");
        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in goBackToHotelInfo",
          err.toString(),
          "goBackToHotelInfo",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    assigni18nObjByLang(pFrom, pTo) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("assigni18nObjByLang");

        retValue = {
          night: this.$t("flightDatePicker.night"),
          nights: this.$t("flightDatePicker.nights"),
          "day-names": [
            this.$t("flightDatePicker.sun"),
            this.$t("flightDatePicker.mon"),
            this.$t("flightDatePicker.tue"),
            this.$t("flightDatePicker.wed"),
            this.$t("flightDatePicker.thur"),
            this.$t("flightDatePicker.fri"),
            this.$t("flightDatePicker.sat")
          ],
          "check-in": this.$t("tariffSetup.stayFrom"),
          "check-out": this.$t("tariffSetup.stayTo"),
          "month-names": [
            this.$t("flightDatePicker.jan"),
            this.$t("flightDatePicker.feb"),
            this.$t("flightDatePicker.mar"),
            this.$t("flightDatePicker.apr"),
            this.$t("flightDatePicker.may"),
            this.$t("flightDatePicker.jun"),
            this.$t("flightDatePicker.july"),
            this.$t("flightDatePicker.aug"),
            this.$t("flightDatePicker.sep"),
            this.$t("flightDatePicker.oct"),
            this.$t("flightDatePicker.nov"),
            this.$t("flightDatePicker.dec")
          ]
        };
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in assigni18nObjByLang",
          err.toString(),
          "assigni18nObjByLang",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    onChangeStayFromDate(pDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeStayFromDate");
        this.hotelTariffObj.fromDate = pDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in onChangeStayFromDate",
          err.toString(),
          "onChangeStayFromDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onChangeStayToDate(pDate) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeStayToDate");
        this.hotelTariffObj.toDate = pDate;
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.TARIFF_NEW,
          "error in onChangeStayToDate",
          err.toString(),
          "onChangeStayToDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    }
  },
   beforeCreate() {    
   addClassToBody(COMPONENT_NAME.TARIFF_NEW);
  },
  
   beforeDestroy() {
       removeClassBody();
    },
};
</script>